export const MENUITEMS = [
	{
		Items: [
			{
				title: "Dashboard",
				key: "dashboard",
				icon: "dashboard",
				type: "link",
				active: false,
				path: `${process.env.PUBLIC_URL}/dashboard`
			},
			{
				title: "Search Patient",
				key: "search patient",
				icon: "search",
				type: "link",
				active: false,
				path: `${process.env.PUBLIC_URL}/search-patient`
			},
			{
				title: "Report",
				key: "report",
				icon: "report",
				type: "link",
				active: false,
				path: `${process.env.PUBLIC_URL}/reports`
			},
			// {
			// 	title: "Report",
			// 	key: "report",
			// 	icon: "report",
			// 	type: "sub",
			// 	active: false,
			// 	children: [
			// 		{ path: `${process.env.PUBLIC_URL}/reports`, title: "Reports", type: "link", key: "reports" },
			// 		{ path: `${process.env.PUBLIC_URL}/add-report`, title: "Add Report", type: "link", key: "add_report" },
			// 	],
			// },
		],
	}
];
